import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceIntro, dependantsExcess } from './shared';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>Your bronze category cover starts here, including these important services:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Chemotherapy, radiotherapy and immunotherapy for cancer</Strong>
          </li>
          <li>
            <Strong>Gastrointestinal endoscopy</Strong>
          </li>
          <li>
            <Strong>Joint reconstructions</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    description: (
      <>
        <P>Your bronze category cover starts here, including these important services:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Chemotherapy, radiotherapy and immunotherapy for cancer</Strong>
          </li>
          <li>
            <Strong>Gastrointestinal endoscopy</Strong>
          </li>
          <li>
            <Strong>Joint reconstructions</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    disclaimer: ambulanceIntro.featureDisclaimer,
  },
};
